import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { Button } from "../../common/Button"
import { receptionOrder } from "../../../actions"
import "./style.scss"

const ReceptionOrderScreen = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { isLoading, receptionOrderSuccess, receptionOrderFail } = useSelector(
    (state) => state.orders
  )
  const [barcode, setBarcode] = useState("")
  const debounceTimeout = useRef(null)

  useEffect(() => {
    if (receptionOrderSuccess || receptionOrderFail) {
      setBarcode("")
    }
  }, [receptionOrderSuccess, receptionOrderFail])

  const sendBarcodeToApi = (code) => {
    dispatch(receptionOrder(code))
  }

  const debouncedSendBarcode = (code) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }
    debounceTimeout.current = setTimeout(() => {
      sendBarcodeToApi(code)
    }, 300)
  }

  const handleInputChange = (event) => {
    const code = event.target.value
    setBarcode(code)
    debouncedSendBarcode(code)
  }

  return (
    <div className="reception">
      <h1>קליטת הזמנות</h1>
      <div>
        <input
          type="text"
          value={barcode}
          onChange={handleInputChange}
          placeholder="מספר הזמנה"
          autoFocus
        />
      </div>
      {isLoading && <p>Loading...</p>}
      {receptionOrderSuccess && (
        <p className="success-message">הזמנה נקלטה בהצלחה.</p>
      )}
      {receptionOrderFail && <p className="error-message">הזמנה לא נקלטה.</p>}
    </div>
  )
}

export default ReceptionOrderScreen
